<template>
  <div class="country_content_wrapper">
    <Tabbar :title="$t('country.title')" :back="onBack"></Tabbar>
    <div class="country_content">
      <van-index-bar :index-list="indexList">
        <template v-for="item in countryList">
          <van-index-anchor
            :index="item.countryType"
            :style="{ textAlign: $store.state.isMirroring ? 'right' : 'left', height: '0.48rem' }"
          >
            {{ item.countryType === '🔥' ? $t('country.popular') : item.countryType }}
          </van-index-anchor>
          <template v-for="each in item.data">
            <van-cell @click="chooseCountry(each)">
              <img v-bind:src="each.countryFlagUrl" class="country_select_img" alt="" />
              <p class="country_detail_name">{{ each.countryName }}</p>
              <div class="area_code">+{{ each.areaCode }}</div>
            </van-cell>
          </template>
        </template>
      </van-index-bar>
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import Vue from 'vue'
import { IndexBar, IndexAnchor } from 'vant'

Vue.use(IndexBar)
Vue.use(IndexAnchor)

export default {
  name: 'Country',
  data() {
    return {
      countryList: [],
      indexList: []
    }
  },
  components: {
    Tabbar
  },
  created: function () {
    this.getCountryList()
  },
  methods: {
    getCountryList() {
      this.$http
        .get(window.serverPath + `/api/country/getNewAreaCodeList`)
        .then((res) => {
          const data = res.data
          if (data && data.code === '200') {
            const countryList = []
            const indexList = []
            res.data.data.forEach((item) => {
              if (item.popularFlag === 1) {
                indexList.push('🔥')
                countryList.push({
                  countryType: '🔥',
                  data: item.data
                })
              } else {
                indexList.push(item.countryType)
                countryList.push({
                  countryType: item.countryType,
                  data: item.data
                })
              }
            })
            this.countryList = countryList
            this.indexList = indexList
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    chooseCountry(item) {
      const redirect = this.$route.query.redirect
      this.$router.replace({
        name: redirect,
        params: {
          country: item,
          areaCode: item.areaCode,
          loginType: this.$route.params.loginType,
          data: this.$route.params.data
        },
        query: {
          ...this.$route.query.params
        }
      })
    },
    onBack() {
      const redirect = this.$route.query.redirect
      this.$router.replace({
        name: redirect,
        params: {
          loginType: this.$route.params.loginType,
          data: this.$route.params.data
        }
      })
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.country_content_wrapper {
  background: #fff;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.country_content {
  width: 100%;
  height: calc(100% - 0.44rem);
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
  scrollbar-width: none;
}

.country_content::-webkit-scrollbar {
  height: 0;
  width: 0;
}

.country_select_img {
  width: 0.18rem;
  height: 0.18rem;
  margin-inline-end: 0.04rem;
  overflow: hidden;
  flex: none;
  border-radius: 10px;
}

.country_detail_name {
  color: #443956;
  font-size: 0.16rem;
  font-family: 'PingFang SC';
  font-weight: 400;
}

.area_code {
  margin-inline-start: auto;
  color: #443956;
  font-size: 0.16rem;
  font-family: 'PingFang SC';
  font-weight: 400;
}
</style>

<style>
.country_content_wrapper .van-index-anchor {
  height: 0.48rem;
  padding: 0.1rem 0.18rem;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
}

.country_content_wrapper .van-cell__value--alone {
  display: flex;
  align-items: center;
}

.country_content_wrapper .van-cell {
  padding-left: 0.18rem;
  font-size: 0.16rem;
  color: #443956;
  height: 0.48rem;
  width: 3.2rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.country_content_wrapper .van-cell::after {
  content: unset;
}

.country_content_wrapper .van-index-bar__index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0;
  width: 0.13rem;
  height: 0.13rem;
  margin-bottom: 0.05rem;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.09rem;
  font-style: normal;
  font-weight: 600;
}

.country_content_wrapper .van-index-bar__index--active {
  color: #fff;
  border-radius: 0.04rem;
  background: #3fbb70;
}

.country_content_wrapper .van-index-bar__sidebar {
  max-height: 70%;
  width: 0.37rem;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Country.vue